import { NavLink, Link } from 'react-router-dom';
import styled from 'styled-components';

import { colors } from '~/styles/colors';

export const Wrapper = styled.div`
display: flex;
flex-direction: column;
`;

// verificar aqui depois, border bottom com outra cor
export const Content = styled.div`
display: flex;
align-items: end;
overflow: visible;
padding: 0;
height: 44px;
max-width: 100%;
border-bottom: 1px solid ${colors.Grey150};
margin: 0;
justify-content: space-between;

@media (max-width: 1240px) {
  height: 48px;
  overflow-x: scroll;
}
`;

export const StyledList = styled.ul`
display: flex;
flex-direction: row;
align-items: center;
justify-content: flex-start;
list-style: none;
padding: 0;
margin-bottom: -1px;
li:not(:first-child) {
  margin-left: 32px;
}
.active {
  color: ${colors.Blue300};
}
`;

export const StyledList2 = styled.ul`
display: flex;
flex-direction: row;
align-items: center;
justify-content: flex-start;
list-style: none;
padding: 0;
margin-left: 32px;
margin-bottom: 0;
.active {
  color: ${colors.Blue300};
}
`;

export const StyledItem = styled.li`
position: relative;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
white-space: nowrap;
gap: 5px;
`;

export const StyledLink = styled(NavLink)`
position: relative;
display: inline-flex;
align-items: center;
gap: 8px;
color: #525866;
font-size: 13px;
font-weight: bold;
text-decoration: none;
  :hover {
    color: ${colors.Blue300};
  }
`;

export const TabIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: currentcolor;
  flex-shrink: 0;
`;

export const StyledLink2 = styled(Link)<{ isActive: boolean }>(({ isActive }) => `
color: ${isActive ? colors.Blue300 : colors.Grey500};
font-size: 13px;
font-weight: bold;
text-decoration: none;
  :hover {
    color: ${colors.Blue300};
  }

`);

export const StyledLine = styled.div<{ isActive }>(
  ({ isActive }) => `
background: ${isActive ? colors.Blue300 : 'transparent'};
width: 100%;
height: 4px;
animation: grow .5s;
border-radius: 3px 3px 0 0;

@keyframes grow {
  from {
    width: 0;
  }
  to{
    width: 100%;
  }
}
`,
);

export const NewBadge = styled.span`
  position: absolute;
  top: -16px;
  right: -24px;
  background-color: ${colors.Blue300};
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1;
  white-space: nowrap;

  /* Sombra sutil para destacar */
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);

  @media (max-width: 1024px) {
    font-size: 9px;
    top: -10px;
    right: -12px;
  }

  @media (max-width: 768px) {
    font-size: 8px;
    top: -8px;
    right: -12px;
    padding: 1px 4px;
  }

  @media (max-width: 480px) {
    font-size: 7px;
    top: -8px;
    right: -6px;
    padding: 1px 3px;
  }
`;
